export default __webpack_public_path__ + "static/media/exhibit.3780d009.png";